import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(
    /* webpackChunkName: "AttachmentsCompact", webpackPrefetch: true */ './lazyIndex');
});
// Delayed Loaded Components
export var AttachmentCompactView = createLazyComponent(lazyModule, function (m) { return m.AttachmentCompactView; });
//# sourceMappingURL=index.js.map